import SmallDetails from "components/SmallDetails/SmallDetails";
import React from "react";
import { AccessTypeSidePanel } from "./AccessTypeSidePanel";
import { getGuestlistListText } from "utilities/enumutils";
import { Message } from "semantic-ui-react";

interface AccessTypesListProps {
  lists: server.dto.GuestlistList[]
  guestlistId: number
}

export const AccessTypesList = (props: AccessTypesListProps) => {

  return <div className="flex-column gap">
    {props.lists.length === 0 && <Message color="purple">{RESX.GuestlistErrors.AddAtLeast1List}</Message>}
    {props.lists.map(at => <SmallDetails
      key={at.guestlistAccessTypeId}
      label={<AccessTypeSidePanel
        list={at}
        trigger={<a>{getGuestlistListText(at)}</a>}
      />}
      subLabel={`${at.paxInUse}/${at.quantity} PAX`}
    />)}
  </div>
}